import { useLazyQuery } from "@apollo/client/react"; import React, { useEffect, useMemo, useState } from 'react';

import toast, { Toaster } from 'react-hot-toast';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { GET_INDICATIONS_NOTIFICATIONS } from '../../../data/graphQL/queries/ResumenIngresoValidation/getIndicationsNotificationsRI';
import './riValidationSearch.scss';
import { useTipoModuloEnum } from '../hooks/useTipoModuloEnum';
import { useGetFilters } from '../hooks/useGetFilters';
import { useGetColumns } from '../hooks/useGetColumns';
import { useTabsInicio } from '../hooks/useTabsInicio';
import { useGetEstados } from '../hooks/useGetEstados';
import { useGetDataByTab } from '../hooks/useGetDataByTab';
import { FiltersHeader } from './FiltersHeader';
import { TabsHeader } from './TabsHeader';
import moment from 'moment';
import { CircularProgress, Card, CardContent } from '@mui/material';

export const RIValidationContent = () => {
  const [notificaciones, setNotificaciones] = useState([]);
  const [datosOriginal, setDatosOriginal] = useState([]);

  const { tipoModuloEnum, tipoModuloConIndicacion } = useTipoModuloEnum();

  const {
    delegacionLoading,
    delegaciones,
    delegacionOrigen,
    filters,
    handleChangeFilters,
    applyTextFilter,
    applyClientSideFilters
  } = useGetFilters();

  const { estadosValidacion, estadosRI, loadingEstados } = useGetEstados();

  const { tabs, setTabs, handleClickTab } = useTabsInicio({
    estadosRI,
    handleChangeFilters,
    initialActiveTabEnum: filters.activeTabEnum
  });

  const activeTabEnum = useMemo(() => { return tabs.find((tab) => tab.active)?.enumName; }, [tabs]);
  const estadoValidado = useMemo(() => { return estadosValidacion.find((x) => x.clave === 'Validado')?.idEstadoValidacion; }, [estadosValidacion]);

  const [getIndications, { loading: indicationsLoading, data: dataIndicaciones }] = useLazyQuery(GET_INDICATIONS_NOTIFICATIONS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataIndicaciones) return;
    const counts = dataIndicaciones?.indicationsNotificationsRI || {};

    setTabs((prevTabs) =>
      prevTabs.map((tab) => {
        const countValue = (() => {
          switch (tab.enumName) {
            case 'ASIGNACION':
              return counts.asignacion;
            case 'VALIDACION':
              return counts.validacion;
            case 'INGRESO_INDICACION':
              return counts.ingresoIndicacion;
            case 'CAMBIO_INDICACION':
              return counts.cambioIndicacion;
            case 'CONFIRMAR_EQUIPO':
              return counts.confirmarEquipo;
            case 'CAMBIO_PROGRAMA':
              return counts.cambioPrograma;
            default:
              return tab.count;
          }
        })();

        return { ...tab, count: countValue };
      })
    );
  }, [dataIndicaciones]);

  const { runQuery, loading: notificacionesLoading } = useGetDataByTab({
    filters,
    activeTabEnum,
    setNotificaciones,
    setDatosOriginal
  });

  const estadosOptions = useMemo(() => {
    if (!activeTabEnum) return [];

    const estadoRechazado = estadosRI?.find((x) => x.displayName === 'Rechazado') || {};
    const estadosAsignacion = [{ id: -1, displayName: "Sin Asignación" }, { id: -2, displayName: "Asignado" }, estadoRechazado];
    const estadoDemorado = { id: -1, displayName: "Demorado" };
    const estadosRIValidacion = estadosRI?.map((x) => x.displayName == 'Aprobado' ? { id: x.id, displayName: 'Realizado' } : x)?.filter((x) => x.displayName !== 'Borrador') || [];

    switch (activeTabEnum) {
      case 'ASIGNACION':
        return estadosAsignacion;
      case 'VALIDACION':
        return [...estadosRIValidacion, estadoDemorado];
      case 'CAMBIO_INDICACION':
      case 'INGRESO_INDICACION':
      case 'CONFIRMAR_EQUIPO':
        return estadosRIValidacion;
      case 'CAMBIO_PROGRAMA':
        return estadosRIValidacion.filter((x) => x.displayName !== 'Correccion');
      default:
        return [];
    }
  }, [activeTabEnum, estadosRI, estadosValidacion]);

  const columns = useGetColumns({ tabs, tipoModuloEnum, tipoModuloConIndicacion, estado: filters.estado, estadosOptions, activeTabEnum, estadoValidado });

  const handleTextFilter = () => {
    if (filters?.txtFiltro?.length >= 2) {
      const dataFiltered = applyClientSideFilters(datosOriginal, filters?.txtFiltro, activeTabEnum, filters.estado, estadosOptions);
      setNotificaciones(dataFiltered);
    } else

      setNotificaciones(datosOriginal);
  };

  const handleTextClean = () => {
    handleChangeFilters('txtFiltro', '');
    setNotificaciones(datosOriginal);
  };

  useEffect(() => {
    handleTextFilter();
  }, [datosOriginal]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    handleChangeFilters(name, value);
  };

  const handleChangeEstado = (e) => {
    const { value } = e.target;
    handleChangeFilters('estado', value);
  };

  const handleChangeFechaDesde = (value) => {
    handleChangeFilters('fechaDesde', moment(value).format('yyyy-MM-DD HH:mm:ss'));
  };

  const handleChangeFechaHasta = (value) => {
    handleChangeFilters('fechaHasta', moment(value).format('yyyy-MM-DD HH:mm:ss'));
  };

  useEffect(() => {
    if (!notificacionesLoading && delegacionOrigen > 0) {
      runQuery();
      getIndications({
        variables: {
          idDelegacion: filters?.idDelegacion
        }
      });
    }
  }, [delegacionOrigen, filters?.idDelegacion]);

  const filtrosValidos = () => {
    if (filters.estado === estadoValidado && filters?.fechaDesde == "") {
      toast.error("La Fecha Desde es obligatoria.");
      return false;
    }
    if (filters.estado === estadoValidado && filters?.fechaHasta == "") {
      toast.error("La Fecha Hasta es obligatoria.");
      return false;
    }
    if (filters?.fechaHasta < filters?.fechaDesde) {
      toast.error("La Fecha Hasta no puede ser anterior a la Fecha Desde.");
      return false;
    }
    return true;
  };

  const handleSearch = () => {
    if (!notificacionesLoading && filtrosValidos()) {
      runQuery();
      getIndications({
        variables: {
          idDelegacion: filters?.idDelegacion
        }
      });
    }
  };

  useEffect(() => {
    runQuery();
    getIndications({
      variables: {
        idDelegacion: filters?.idDelegacion
      }
    });
  }, [activeTabEnum, filters.estado]);

  if (loadingEstados || delegacionLoading) {
    return <Card elevation={1}>
      <CardContent sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '30vh'
      }}>
        <CircularProgress size={40} />
      </CardContent>
    </Card>;
  }

  return (
    <>

      <div className='grid-container'>
        <FiltersHeader
          delegaciones={delegaciones}
          estado={filters.estado}
          activeTabEnum={activeTabEnum}
          estadoValidado={estadoValidado}
          estadosOptions={estadosOptions}
          filters={filters}
          handleChangeEstado={handleChangeEstado}
          handleChange={handleChange}
          handleChangeFechaDesde={handleChangeFechaDesde}
          handleChangeFechaHasta={handleChangeFechaHasta}
          handleTextFilter={handleTextFilter}
          handleTextClean={handleTextClean}
          handleSearch={handleSearch}
          handleChangeFilters={handleChangeFilters} />

        <TabsHeader
          tabs={tabs}
          handleClickTab={handleClickTab}
          notificacionesLoading={notificacionesLoading}
          indicationsLoading={indicationsLoading}
          runQuery={runQuery} />

        <DataGridGenerico
          columns={columns}
          rows={notificaciones}
          toolbar={false}
          loading={notificacionesLoading} />

      </div>
    </>);

};